//@flow
import Constants    from '../constants';
import Dispatcher   from '../dispatcher';
import SessionApiInterface from '../APIInterfaces/session';
import FB from '../Utils/fb-interface';

export default {
  loginWithUsernamePassword(username:string, password:string) {
    Dispatcher.dispatchAction(Constants.LOGIN_PENDING, { username, password });
  },

  loginFromData(userData:{ access_token:string, user_id:string }){
    Dispatcher.dispatchAction(Constants.LOGGED_IN, userData);
  },

  loggedOut() {
    Dispatcher.dispatchAction(Constants.LOGGED_OUT);
  },

  logout() {
    Dispatcher.dispatchAction(Constants.LOGOUT);
  },

  removeLoginError() {
    Dispatcher.dispatchAction(Constants.REMOVE_LOGIN_ERROR);
  },

  loginWithFB() {
    FB.login((response) => {
      if (!response || !response.authResponse) return;
      SessionApiInterface.getTokenWithFacebook(response.authResponse.accessToken);
    }, {scope: 'public_profile,email'});
  },

  loginWithMagicLink(token:string) {
    Dispatcher.dispatchAction(Constants.LOGIN_WITH_MAGIC_LINK, {token});
  },

  loginWithSoftLink(token:string) {
    Dispatcher.dispatchAction(Constants.LOGIN_WITH_SOFT_LINK, {token});
  },
};
